module.exports = {
    resolution: {width:800, height:600},
    loadscreen: {
        loadbar:{
            position:{x:179, y:536}
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./cfg/screen-config.js
// module id = 21
// module chunks = 0